/**
 * How a person's given names are matched across sources.
 *
 * This file is consumed by `@shaarp/ui`. `@shaarp/api` cannot import a runtime
 * value from this package (its barrel re-exports a directory, which Node
 * refuses to resolve from the API's CommonJS build), so it keeps a mirrored
 * copy in `api/src/common/utils/person-name.ts`, held to this one by
 * `api/src/common/utils/person-name-parity.spec.ts`. Keep both in sync.
 */

/**
 * The first given name of a stored list ("Jean Pierre", "Jean, Pierre" →
 * "Jean"). The registry lists every given name; gouv, beneficial owners,
 * LinkedIn profiles and the mandates lookup carry the first one only, so that
 * is the one to match a person by.
 */
export function firstGivenName(firstName: string): string {
  return firstName.split(/[\s,]+/).find(Boolean) ?? "";
}
